import { useEffect, useState } from "react";
import axios from 'axios'
import './App.css';

const View = ({ message }) => (
  <div className="App">
    <header className="App-header">
      <p>
        {message}
      </p>
    </header>
  </div>
);

function App() {
  const [message, setMessage] = useState(null);
  useEffect(() => {
    const fetchHealthy = async () => {
      const response = await axios.get("api/healthy")
      setMessage(`Hello, I am ${response.data}`);
    };
    fetchHealthy();
  }, []);

  return (
    <View { ...{ message } } />
  );
}

export default App;
